/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPeopleFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconPeopleFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPeopleFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPeopleFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZYr53F': alignSelf,'--mt-2-ZYr53F': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZYr53F': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZYr53F': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZYr53F': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZYr53F': opacity,'--w-10-ZYr53F': typeof width === 'number' ? `${width}px` : width,'--h-11-ZYr53F': typeof height === 'number' ? `${height}px` : height,'--a-7-ZYr53F': isAnimated ? animation : "none",'--sd-8-ZYr53F': isAnimated ? strokeDashoffset : 0,'--sd-9-ZYr53F': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPeopleFilled.SvgPath"
  data-view-path={viewPath}
 d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
 style={{'--f-12-ZYr53F': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}